import React from 'react'
import styled from 'styled-components'

import { FiEdit2, FiTrash2 } from 'react-icons/fi'

export const AdminActionRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  float: right;

  & > button {
    border: ${(props) => props.theme.colors.lightGrey} solid 0;
    border-right-width: 1px;

    &:last-child {
      border-width: 0;
    }
  }
`

export const AdminAction = styled.button`
  background: transparent;
  border: 0;
  padding: 5px 20px;
  margin: 0;

  svg {
    height: 20px;
    width: 20px;
    transition: all 0.25s;
  }

  &:hover {
    svg {
      transition: all 0.25s;
      transform: scale(1.2);
    }
  }
`

export const AdminEdit = (props) => (
  <AdminAction {...props}>
    <FiEdit2 />
  </AdminAction>
)

export const AdminDelete = (props) => (
  <AdminAction {...props}>
    <FiTrash2 />
  </AdminAction>
)
